import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

import {getData} from '@/api/module/dms';
import {openBlob} from '@/util';
import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiDownloadItem',
  props: {
  title: {
    type: String,
    required: false,
  },
  token: {
    type: String,
    required: true,
  },
  fileName: {
    type: String,
    required: true,
  },
  elevation: {
    type: Number,
    default: 0,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;
const loading = ref(false);
async function downloadData() {
  loading.value = true;
  const data: Blob = await getData(props.token);
  loading.value = false;
  await openBlob(data, props.fileName);
}

__expose({
  downloadData,
  loading,
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: downloadData,
    loading: loading.value,
    elevation: __props.elevation
  }, {
    append: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            size: "24",
            width: "3"
          }))
        : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-download")
            ], undefined, true),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, { style: {"white-space":"normal"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title ?? 'Herunterladen'), 1)
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }, 8, ["loading", "elevation"]))
}
}

})